import { DollarCircleOutlined } from '@ant-design/icons';
import { Card, Col, Empty, Row } from 'antd';
import styles from './index.module.scss';
import { capitalizeFirstLetter } from 'utils/utils';

type Props = {
	employeeData: any;
};

const TaxationDetails = ({ employeeData }: Props) => {
	const taxationDetails = employeeData?.TaxationDetails;

	const displayYes = () => 'Yes';
	const displayNo = () => 'No';

	return (
		<div className={styles['taxation-details']}>
			<Card
				title={
					<div className={styles['card-title']}>
						{' '}
						<DollarCircleOutlined style={{ marginRight: 8 }} />
						Taxation Details
					</div>
				}
				bordered={false}
				className={styles['card']}
			>
				{!taxationDetails ? (
					<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
				) : (
					<Row gutter={16}>
						<Col span={12}>
							<p className={styles['card-text']}>
								<b>Employee TPIN :</b>{' '}
								{taxationDetails.employeeTPIN || '-'}
							</p>
						</Col>
						<Col span={12}>
							<p className={styles['card-text']}>
								<b>Currency :</b>{' '}
								{taxationDetails.companyCurrency.currency ||
									'-'}
							</p>
						</Col>
						<Col span={12}>
							<p className={styles['card-text']}>
								<b>Employment Type :</b>{' '}
								{capitalizeFirstLetter(
									taxationDetails.employmentType
								) || '-'}
							</p>
						</Col>
						<Col span={12}>
							<p className={styles['card-text']}>
								<b>Taxation Method :</b>{' '}
								{capitalizeFirstLetter(
									taxationDetails.taxationMethod
								)}
							</p>
						</Col>
						<Col span={12}>
							<p className={styles['card-text']}>
								<b>Enable Gross Up Tax :</b>{' '}
								{taxationDetails.enableGrossUpTax
									? displayYes()
									: displayNo()}
							</p>
							<b>Employee with Disabilities :</b>{' '}
							{taxationDetails.disabilities
								? displayYes()
								: displayNo()}
						</Col>
					</Row>
				)}
			</Card>
		</div>
	);
};

export default TaxationDetails;
